export default function SectionContact() {
  return (
    <section id="contact" className="scroll-mt-20 py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-4xl mx-auto">
        <div className="relative overflow-hidden rounded-2xl bg-primary-500 p-8 md:p-12">
          <div className="absolute top-0 right-0 w-48 h-48 md:w-64 md:h-64 bg-primary-400/30 rounded-full -translate-y-1/2 translate-x-1/4"></div>
          <div className="absolute bottom-0 left-0 w-36 h-36 md:w-48 md:h-48 bg-primary-600/20 rounded-full translate-y-1/2 -translate-x-1/4"></div>

          <div className="relative z-10 text-center">
            <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-background-50/20 flex items-center justify-center">
              <i className="ri-mail-send-line text-2xl text-background-50"></i>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl text-background-50 mb-3">
              投稿爆料
            </h2>
            <p className="text-sm md:text-base text-background-50/80 max-w-lg mx-auto mb-8 leading-relaxed">
              你有独家爆料？知道不为人知的内幕？欢迎向51吃瓜大赛投稿，你的爆料可能成为下一个全网热搜。我们严格保护爆料人隐私，匿名投稿同样欢迎。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="mailto:tougao@51chigua.example.com"
                className="w-full sm:w-auto px-8 py-3 bg-background-50 hover:bg-background-100 text-primary-600 font-medium rounded-lg transition-colors duration-200 text-center cursor-pointer whitespace-nowrap text-sm"
              >
                <i className="ri-mail-line mr-2"></i>
                邮件投稿
              </a>
              <span className="text-background-50/60 text-sm whitespace-nowrap">
                或直接发送至 tougao@51chigua.example.com
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}